import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {TableComponent} from 'app/components/common/table/table.component';
// import {BackupService} from "../../../../services/rest/backup.service";

@Component({
  selector: 'app-file-tree-table',
  templateUrl: './file-tree-table.component.html',
  styleUrls: ['../table.component.css', './file-tree-table.component.css'],
  providers: [
    { provide: TableComponent, useExisting: forwardRef(() => FileTreeTableComponent) },
    // BackupService
  ]
})
export class FileTreeTableComponent extends TableComponent {

  //private static REGEX: RegExp = /[A-Za-zÀ-ú\w\d_ \-\.]+$/;
  /**
   * Expressão regular que obtém o último trecho do path de um arquivo/diretório
   */
  private static REGEX: RegExp = /[^\/]*$/;
  @Input() piped;
  @Input() rootDir;
  @Output() requestRootDir = new EventEmitter();

  breadCrumbItems: Array<any> = [];

  // constructor(private backupService: BackupService) {
  //   super();
  //  }

  constructor() {
    super();
  }

   ngOnDestroy() {
    this.clearBreadCrumb();
   }

   ngOnChanges() {
    this.clearBreadCrumb();
   }

  renderPathName(item: any, property: any): string {
    let pre = super.render(item, property);
    return FileTreeTableComponent.REGEX.exec(pre) ? FileTreeTableComponent.REGEX.exec(pre)[0] : pre;
  }

  private handleIcons(item): object {
    return {
      'fa-folder-open-o': item.type === 'D',
      'fa-file': item.type === 'F'
    };
  }

  private getChildren(item) {
    const parentId = item.id;
    if(this.breadCrumbItems.indexOf(item) == -1) {
      this.breadCrumbItems.push(item);
    } else {
      const itemIndex = this.breadCrumbItems.indexOf(item);
      this.breadCrumbItems = this.breadCrumbItems.slice(0, itemIndex + 1);
    }

    // this.backupService.listChildren(parentId).subscribe(
    //   next => {
    //     this.source = next;
    //   }, error => console.log(error)
    // );
  }

  clearBreadCrumb() {
    this.breadCrumbItems = [];
  }

  getRootDir() {
    this.clearBreadCrumb();
    this.requestRootDir.emit({value: this.rootDir});
  }
}
